import { render, staticRenderFns } from "./polling.vue?vue&type=template&id=5e49ad0b&scoped=true"
import script from "./polling.vue?vue&type=script&lang=js"
export * from "./polling.vue?vue&type=script&lang=js"
import style0 from "./polling.vue?vue&type=style&index=0&id=5e49ad0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49ad0b",
  null
  
)

export default component.exports